import React             from 'react';
import { Redirect }      from 'react-router-dom';
import { authRoles }     from 'auth/auth';
import Student           from './Student';
import StudentList       from './StudentList';
import StudentLessonList from './StudentLessonList';
import StudentEventList  from './StudentEventList';
import StudentCourseList from './StudentCourseList';
import FileUpload        from 'main/components/upload/FileUpload';

export const StudentConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.instructor,
    routes  : [
        {
            path      : '/student/:view_type/:student_id',
            component : Student,
            permission: { component_name: 'student', permission_type: 'view_type' },
        },
        {
            path      : '/student/list',
            component : StudentList,
            permission: { component_name: 'student', permission_type: 'list' },
        },
        {
            path      : '/student/events',
            component : StudentEventList,
        },
        {
            path      : '/student/lessons',
            component : StudentLessonList,
        },
        {
            path      : '/student/courses',
            component : StudentCourseList,
        },
        {
            path      : '/student/:view_type/',
            component : Student,
            permission: { component_name: 'student', permission_type: 'view_type' },
        },
        {
            path: '/student',
            component: () => <Redirect to="/student/list" />,
            permission: { component_name: 'student', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/student/StudentConfig.js